import {} from '@busybusy/webapp-react-ui';
import FlexContainer from '@busybusy/webapp-react-ui/dist/components/FlexContainer/FlexContainer';
import { EquipmentModelType } from '__generated__/graphql';
import classNames from 'classnames';
import SearchBar from 'components/foundation/SearchBar/SearchBar';
import { t } from 'i18next';
import { ClassName } from 'types/ClassName';
import { Nullable } from 'types/util/Nullable';
import EquipmentCategoryPickerContainer from '../EquipmentCategoryPicker/EquipmentCategoryPicker';
import { EquipmentTypePicker } from '../EquipmentTypePicker/EquipmentTypePicker';

export interface IEquipmentAddOnDialogHeaderProps {
  className?: ClassName;
  selectedType: Nullable<EquipmentModelType>;
  onTypeSelect: (value: Nullable<EquipmentModelType>) => void;
  selectedCategory: Nullable<string>;
  onCategorySelect: (value: Nullable<string>) => void;
  searchValue: string;
  setSearchValue: (value: string) => void;
}

const EquipmentAddOnDialogHeader = (props: IEquipmentAddOnDialogHeaderProps) => {
  const { className, searchValue, selectedCategory, selectedType, setSearchValue, onCategorySelect, onTypeSelect } =
    props;

  const classes = classNames('equipment-add-on-dialog-header', className);

  return (
    <FlexContainer className={classes} flexDirection="column">
      <FlexContainer className="mb-5" justifyContent="space-between">
        <FlexContainer.Item flexBasis="48%">
          <EquipmentTypePicker value={selectedType} onSelect={onTypeSelect} placeholder={t('All Types')} />
        </FlexContainer.Item>
        <FlexContainer.Item flexBasis="49%">
          <EquipmentCategoryPickerContainer
            onSelect={onCategorySelect}
            value={selectedCategory}
            placeholder={t('All Categories')}
          />
        </FlexContainer.Item>
      </FlexContainer>
      <SearchBar search={searchValue} onSearch={setSearchValue} />
    </FlexContainer>
  );
};

export default EquipmentAddOnDialogHeader;
